import { AbstractControl, FormGroup } from '@angular/forms';

// tslint:disable: max-line-length

export const formUtils = {
  /**
   * Regex validators
   */
  regex: {
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
  },
  /**
   * Form control validators
   */
  validators: {
    email: ({ value }: AbstractControl) => {
      return value && formUtils.regex.email.test(String(value).toLowerCase()) ? null : { pattern: true };
    }
  },
  /**
   * Marks form controls as touched/dirty
   */
  touchControls: (controls: { [key: string]: AbstractControl }): void => {
    Object.keys(controls).forEach(key => {
      if (!Object.prototype.hasOwnProperty.call(controls, key)) {
        return;
      }

      controls[key].markAsTouched();
      controls[key].markAsDirty();

      const formGroup = controls[key] as FormGroup;
      if (formGroup.controls) {
        formUtils.touchControls(formGroup.controls);
      }
    });
  }
};

export const getAppBaseUrl = (contextPath: string): string => {
  const origin = window.location.origin;
  if (origin === 'http://localhost:4200') {
    return 'http://localhost:8080' + contextPath;
  } else {
    return origin + contextPath;
  }
};

export const isEmbedded = (): boolean => {
  const cookieName = 'oauth2_embedded';
  let embedded = false;
  const embeddedCookie = document.cookie.split(';').find((s) => (s.trim().startsWith(cookieName)));
  if (embeddedCookie) {
    const value = embeddedCookie.trim().substring(cookieName.length+1).toLowerCase();
    embedded = (value === 'true');
  }
  return embedded;
}
